export const REMOVE_ANSWER = "REMOVE_ANSWER"
export const REMOVE_ANSWER_SUCCESS = "REMOVE_ANSWER_SUCCESS"
export const REMOVE_ANSWER_CLEAN = "REMOVE_ANSWER_CLEAN"
export const REMOVE_ANSWER_ERROR = "REMOVE_ANSWER_ERROR"
